
export const SP_LANDING = 'SP_LANDING';
export const EXTRA_QUESTION_MAX_LENGTH = 1024;
export const BACK_URL = 'BackUrl';
